import React from "react";
import ParagraphTag from "../../../reusebale/Paragraph";
import ImageTag from "../../../reusebale/imageTag";

const terminationReason = ({ data, reason, amount }) => {
  return (
    <div className="bg-white rounded-xl p-2">
      <div className="px-4 pt-4">
        <ParagraphTag
          content="Lease Terminated"
          classes="text-darkColor font-popinsSemiBold text-lg mt-[-3px]"
        />
      </div>
      <div className="flex mt-1">
        <div className="w-[70%] px-2">
          <div className="pt-3">
            <ParagraphTag
              content="Reason"
              classes="text-darkColor font-popinsSemiBold text-sm"
            />
            <ParagraphTag
              content={`${reason}`}
              classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
            />
          </div>
          <div className="pt-3">
            <ParagraphTag
              content="Refund Amount"
              classes="text-darkColor font-popinsSemiBold text-sm"
            />
            <ParagraphTag
              content={`${amount}`}
              classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default terminationReason;
